
import { Column, Row, Spacer, Text } from '@components/1-atoms';
import ListItem, { ListItemData, Props as ListItemProps, ListSectionHeader } from '@components/2-molecules/ListItem';
import Tab, { TabContainer } from '@components/2-molecules/Tab';
import styled, { css } from '@emotion/native';
import React, { FC } from 'react';

import ModuleIcon from '@assets/icons/modules/documents';

import * as utils from '@lib/utils';
import { Platform, SectionList as RNSectionList, SectionListProps, SectionListRenderItem } from 'react-native';
import _ from 'underscore';

// Define the shape of our item and section data
interface Item extends ListItemData {
    id: string;
    name: string;
    contact: { name: string };
    dueDate: string;
    grandTotal: number | string;
    createdAt: string | number | Date;
}

type Section = { title: string; data: ReadonlyArray<Item> };

const SectionList = styled(RNSectionList<Item, Section>)``;

const View = styled.View``;


export type Props = Omit<ListItemProps, 'children' | 'onPress' | 'data'> & {
    currency: string;
    data: Item[];
    children?: undefined;
    onPress?: (data: ListItemData) => void;
} & Omit<SectionListProps<Item>, 'renderItem' | 'sections'>;

const DocumentList: FC<Props> = ({ currency, data, onPress, ...props }) => {

    const sectionedData = _.chain(data)
        .sortBy((document) => document.createdAt)
        .reverse()
        .groupBy(_.property(['createdAt']))
        .map((documents: any, key: string) => ({
            title: `Created on ${utils.formatDate(key)}`,
            data: documents,
        }))
        // .value() unwraps the Underscore object to return the final result.
        .value();

    const _renderItem: SectionListRenderItem<Item, Section> = ({ item }) => {
        const name = item.contact.name;
        const sub = item.name;
        const subright = undefined; // `Due on ${utils.formatDate(item.dueDate)}`;
        const right = <Text currency={currency}>{item.grandTotal}</Text>;

        return (
            <View>
                <ListItem {...props} onPress={() => { onPress?.(item) }} sub={sub} subright={subright} right={right}>
                    {name}
                </ListItem>
                <Spacer h={0.5} />
            </View>
        );
    };

    {/* Empty list message box */ }
    if (data?.length === 0) {
        return (
            <View>
                <Spacer h={3} />
                <Row style={{ justifyContent: 'center' }}>
                    <ModuleIcon {...props} />
                </Row>
                <Spacer h={.9} />
                <Row>
                    <Column>
                        <Text align='center' {...props}>I can manage all my documents </Text>
                        <Text align='center' {...props}>here. Tap <Text large bold>+</Text> to create my first </Text>
                        <Text align='center' {...props}>one.</Text>
                    </Column>
                </Row>
                <Spacer h={3} />
            </View>);
    } else {
        return (
            <View>
                {/* Tabs */}
                <TabContainer>
                    {/* TODO: Display a list of grouped document type tabs. Using index as key for now. */}
                    {((data?.length > 0) ? [1] : []).map((document, index) => (<Tab key={index} selected name={`ESTIMATES (${data?.length})`} />))}
                </TabContainer>
                <Spacer h={2} />

                {/* Document list */}

                {/* CASE 1: */}
                {/* The `AppTemplate` provides a main ScrollView that wraps all the page content. */}
                {/* This ScrollView's job is to allow the entire page content to scroll if its content */}
                {/* is taller than the screen. */}

                {/* This SectionList is itself a scrollable view. */}
                {/* However, nested while not supported in react-native is supported in react-native-web */}

                {/* CASE 2: */}
                {/* The SectionList tries to render with an infinite height, which causes the outer ScrollView */}
                {/* to think its content is infinitely tall. This breaks the layout, often causing the list to expand */}
                {/* and push everything below it off-screen, which is exactly the behavior you were seeing. */}

                {/* WARNINGS ⚠️ : The list has a infinite height when the following styles are removed.  */}
                {/*               The view contains the list inside its immediate container.*/}
                <View style={css(`width: 100%; height: auto; `)}>
                    <SectionList
                        scrollEnabled={(Platform.OS === 'web') ? true : false}
                        sections={sectionedData as Section[]}
                        keyExtractor={(item) => `${item.id}`}
                        renderItem={_renderItem}
                        renderSectionHeader={({ section: { title } }) => <ListSectionHeader children={title} />}
                        renderSectionFooter={() => <Spacer h={1} />}
                    />
                </View>
            </View>
        );
    }

};

export default DocumentList;